import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import ArticleCard from '@/components/base/ArticleCard';
import NewsletterForm from '@/components/base/NewsletterForm';
import { categories, getArticlesByCategory, getCategoryBySlug } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || categories[0].slug);

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
    }
    window.scrollTo(0, 0);
  }, [slug]);

  const currentCategory = getCategoryBySlug(activeSlug);
  const categoryArticles = getArticlesByCategory(activeSlug);

  if (!currentCategory) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <p className="text-foreground-600">分类不存在</p>
      </div>
    );
  }

  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${currentCategory.name} - 亚洲人成长之路`,
          description: currentCategory.description,
          url: `https://snjrh.cn/category/${activeSlug}`,
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="py-4">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: currentCategory.name },
                ]}
              />
            </div>

            <div className="py-8">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className={`${currentCategory.icon} text-2xl`}></i>
                </div>
                <div>
                  <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                    {currentCategory.name}
                  </h1>
                  <p className="text-sm text-foreground-600 mt-1">
                    {currentCategory.description}
                  </p>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2 pb-6 overflow-x-auto flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 pb-14">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.slug} article={article} />
                ))}
              </div>
            ) : (
              <div className="py-20 text-center">
                <p className="text-foreground-500">该分类暂无文章</p>
              </div>
            )}
          </div>

          <NewsletterForm />
        </main>

        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}